import "./hp-logo.css";
export const HpLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="hp-logo" viewBox="0 0 96 96" fill="#0096D6">
      <defs>
        <path
          id="hpLogo"
          d="M48 96a49.7 49.7 0 0 1-1.426-.022l9.809-26.96h13.5c2.37 0 4.97-1.821 5.781-4.047L86.307 35.74c1.74-4.786-1-8.702-6.093-8.702H61.485L45.771 70.22h-.006l-8.909 24.478C15.721 89.672 0 70.673 0 48 0 25.981 14.827 7.427 35.04 1.772l-9.192 25.265h-.002L10.564 69.018l10.173.001 12.996-35.673h7.646L28.383 69.019l10.169.002 12.11-33.282c1.742-4.786-.999-8.702-6.087-8.702h-8.551L45.843.05C46.558.02 47.277 0 48 0c26.51 0 48 21.49 48 48S74.51 96 48 96Zm29.043-62.68h-7.644L58.697 62.688h7.643L77.043 33.32Z"
        />
      </defs>
      <use href="#hpLogo" />
    </svg>
  );
};
